export default __webpack_public_path__ + "static/media/uefa-icon-active.39e58cf3.webp";